import React, { useState } from 'react'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useDebouncedCallback } from 'use-debounce'

import { Client } from 'src/api/models'
import { skuit } from 'src/services/skuit'
import { useQueryPaginator } from 'src/components/Table'
import { FilterProps } from './types'

export const ClientFilter = (props: FilterProps) => {
  const { label, onChange } = props
  const [client, setClient] = useState<Client | null>(null)
  const paginator = useQueryPaginator(
    'client-filter',
    skuit.sc.clients.list
  )
  const dePaginatorFilters = useDebouncedCallback(paginator.patchFilters, 100)
  return (
    <Autocomplete
      id="client-filter"
      options={paginator.data.results}
      getOptionLabel={(client: Client) => client?.name || ''}
      getOptionSelected={(option, value) => option.guid === value?.guid}
      filterOptions={(option) => option}
      onChange={(event: any, newValue: any | null) => {
        setClient(newValue)
        onChange(newValue, newValue?.guid)
      }}
      value={client}
      renderInput={(params) => (
        <TextField
          {...params}
          name="client-filter"
          label={label}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            dePaginatorFilters.callback({ search: event.target.value })
          }
        />
      )}
    />
  )
}
